<template>
  <div class="ppv-stat-card" @click="$emit('click')">
    <div class="ppv-stat-header">
      <div class="ppv-stat-header-main">
        <v-icon class="ppv-stat-icon">{{ icon }}</v-icon>
        <span class="ppv-stat-label">{{ label }}</span>
      </div>
      <slot name="header-extra" />
    </div>

    <div class="ppv-stat-body">
      <div class="ppv-stat-number-wrap">
        <span class="ppv-stat-number">{{ value }}</span>
        <small v-if="unit" class="ppv-min-label">{{ unit }}</small>
      </div>
      <span v-if="sub" class="ppv-stat-sub">{{ sub }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PpvStatCard',
  emits: ['click'],
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    unit: {
      type: String,
      default: '',
    },
    sub: {
      type: String,
      default: '',
    }
  }
}
</script>

<style scoped>
.ppv-stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaedf2;
  transition: all 0.2s ease;
  min-height: 140px;
  cursor: pointer;
}
.ppv-stat-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.ppv-stat-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}
.ppv-stat-header-main {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.ppv-stat-icon {
  color: #a0aec0 !important;
  font-size: 20px !important;
  flex-shrink: 0;
}
.ppv-stat-label {
  font-size: 13px;
  color: #a0aec0;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1.2;
  margin-top: 2px;
}
.ppv-stat-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.ppv-stat-number-wrap {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.ppv-stat-number {
  font-size: 38px;
  font-weight: 800;
  color: #1a2340;
  line-height: 1;
}
.ppv-min-label {
  font-size: 18px;
  font-weight: 700;
  color: #1a2340;
}
.ppv-stat-sub {
  font-size: 12px;
  color: #a0aec0;
  margin-top: 8px;
  font-weight: 600;
}
</style>
